import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BorderouDatatableComponent } from "./borderou-datatable.component";
import { EditBorderouDatatableComponent } from "./edit-borderou-datatable/edit-borderou-datatable.component";
import { MaterialModule } from "src/app/material.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { AddBorderouDatatableComponent } from './add-borderou-datatable/add-borderou-datatable.component';

@NgModule({
  declarations: [BorderouDatatableComponent, EditBorderouDatatableComponent, AddBorderouDatatableComponent],
  imports: [CommonModule,  
    ReactiveFormsModule, 
    FormsModule, 
    MaterialModule],
  exports: [BorderouDatatableComponent, EditBorderouDatatableComponent],
})
export class BorderouDatatableModule {}
